import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';

import { Pagination } from '@/core/domain/model/pagination';
import Handler from '@/core/domain/usecase/handler';

import { Station } from '@/module/station/domain/model/station';
import { StationPagination } from '@/module/station/domain/model/station_pagination';
import { STATION_API_ENDPOINT } from './constants';

export interface FetchStationRepository {
    (pagination: Pagination): Promise<StationPagination>
}

const fetchStationRepository = (axios: AxiosInstance): FetchStationRepository => async (pagination: Pagination) => {
    try {
        // TODO: move this endpoint to .env
        const response: AxiosResponse<Station[]> = await axios.get(`${STATION_API_ENDPOINT}/station`, {
            params: pagination
        })

        const stationPagination: StationPagination = {items: response.data, total: response.data.length}
        return stationPagination
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchStationRepository
